//Window Resize
function windowIsSmallerThan(width = 0,callbackToRun) {
    width > 0 && callbackToRun()
    return window.innerWidth < width
}

// Dark mode
const setDarkMode = (active) => {
    const wrapper = document.querySelector(":root")
    if (active) {
        wrapper.setAttribute("data-theme", "dark")
        localStorage.setItem("theme", "dark")
    } else {
        wrapper.setAttribute("data-theme", "light")
        localStorage.setItem("theme", "light")
    }
};

const initDarkMode = () => {
    const query = window.matchMedia("(prefers-color-scheme: dark)");
    let active = query.matches;  
    setDarkMode(active);
    query.addEventListener('change', e => setDarkMode(e.matches));
};
initDarkMode()

//Toggle DarkMode
function toggleDarkMode() {
    console.log('testing mode');
    const theme = document.querySelector(":root").getAttribute("data-theme")
    setDarkMode(theme === "light")
};

//Window resized
class ResizeHandler {
    constructor() {
        this.functions = [];
        this.handleResize = this.handleResize.bind(this);
        window.addEventListener('resize', this.handleResize);
    }

    addFunction(fn) {
        if (typeof fn === 'function') {
            this.functions.push(fn);
        } else {
            console.error('Argument must be a function');
        }
    }

    handleResize() {
        this.functions.forEach(fn => fn());
    }
}

//Exports
export {toggleDarkMode, windowIsSmallerThan, setDarkMode, initDarkMode, ResizeHandler}  